<!-- Header -->
<header class="asset-app-header">
  <div class="logo-section">
    <button class="back-btn" (click)="goBack()">
      <app-icon name="go-back" size="16"></app-icon>
    </button>
    <div class="app-logo">VideoX</div>
    <div class="project-crumb">
      @if (videoXDetails?.video?.title) {
        <span>{{ videoXDetails.video.title }}</span> &gt;
        <span>{{ videoXDetails?.title || "VideoX" }}</span>
      } @else {
        <span>New VideoX</span>
      }
    </div>
  </div>
  <div class="header-actions">
    <div class="credit-pill">
      <span>Credits:</span>
      <strong>{{ credits }}</strong>
    </div>
    <button class="btn-purple" (click)="saveToFrameX()">Export</button>
  </div>
</header>

@if (currentView === "home") {
  <div class="view-section">
    <div class="p-4">
      @for (item of videoGallaryList; track item.id) {
        <h4>Scene {{ item?.scene_number }}</h4>

        <div class="grid-container">
          @for (shot of item?.shots; track shot.shotId) {
            <div class="shot-card" (click)="switchView(shot, 'player')">
              <div class="shot-visual">
                <img
                  [src]="
                    shot?.story_images[0]?.image
                      ? shot?.story_images[0]?.image
                      : '../../assets/images/storyboard_default_image.png'
                  "
                  alt="Generated Video"
                />
                @if (shot.aivideos?.length) {
                  <div class="play-overlay">
                    <div class="play-icon-large">▶</div>
                  </div>
                  <div class="video-duration">00:04</div>
                }
                @if (!shot.aivideos?.length) {
                  <div class="empty-state">
                    <span>No Video</span>
                  </div>

                  <div class="shot-overlay-hover">
                    <button
                      class="btn-purple"
                      (click)="onGenerateVideoClick(shot, $event)"
                    >
                      ✨ Generate AI Video
                    </button>
                    <!-- <button class="btn-ghost btn-bordered">Upload Video</button> -->
                  </div>
                }
              </div>

              <div class="shot-info">
                <div>
                  <div class="shot-title">
                    Scene {{ item?.scene_number }} • Shot
                    {{ shot?.shot_number }}
                  </div>
                  <div class="shot-meta">
                    @for (entity of shot.entities; track $index) {
                      <span class="tag">{{ entity?.entity?.name }}</span>
                      @if ($index < shot.entities.length - 1) {
                        <span class="tag-separator">•</span>
                      }
                    }
                  </div>
                </div>
                <span
                  class="status-badge"
                  [ngClass]="{
                    'status-generated': shot.aivideos?.length,
                    'status-empty': !shot.aivideos?.length,
                  }"
                  >{{ shot.aivideos?.length ? "Ready" : "Empty" }}</span
                >
              </div>
            </div>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <!-- Workspace -->
  <div class="workspace">
    <!-- Left Panel: Settings -->
    <aside class="panel panel-left" [class.collapsed]="isLeftPanelCollapsed">
      <div class="panel-header">
        <div class="panel-header-content">
          <div class="panel-title">Generation Control</div>
          <div class="panel-subtitle">Fine-tune motion dynamics</div>
        </div>
        <button
          class="panel-toggle-btn"
          (click)="toggleLeftPanel()"
          [title]="isLeftPanelCollapsed ? 'Expand panel' : 'Collapse panel'"
        >
          {{ isLeftPanelCollapsed ? "→" : "←" }}
        </button>
      </div>

      <div class="panel-content" [class.hidden]="isLeftPanelCollapsed">
        <form [formGroup]="videoGenerationForm">
          <!-- Source: Storyboard Frame Selection -->
          <div class="control-group">
            <div class="control-label">Input Source (Storyboard Frame)</div>

            <!-- Selected Frame Preview -->
            @if (getSelectedFrame().image) {
              <div class="selected-frame-preview">
                <img
                  [src]="getSelectedFrame().image"
                  [alt]="'Selected Frame'"
                />
                <div class="frame-overlay-info">
                  <span class="badge"
                    >Scene {{ getSelectedFrame().scene }} • Shot
                    {{ getSelectedFrame().shot }}</span
                  >
                </div>
              </div>
            }

            <!-- Scenes List -->
            <div class="scenes-list">
              @for (scene of scenes; track scene.id) {
                <div class="scene-item">
                  <div
                    class="scene-header"
                    (click)="toggleScene(scene.id)"
                    [class.expanded]="isSceneExpanded(scene.id)"
                  >
                    <div class="scene-header-content">
                      <span class="scene-number"
                        >Scene {{ scene.scene_number }}</span
                      >
                      <span class="scene-title">{{ scene.scene_title }}</span>
                    </div>
                    <div class="scene-chevron">
                      {{ isSceneExpanded(scene.id) ? "▲" : "▼" }}
                    </div>
                  </div>

                  @if (isSceneExpanded(scene.id)) {
                    <div class="shots-list">
                      @for (shot of scene.shots; track shot.shotId) {
                        <div
                          class="shot-item"
                          [class.selected]="
                            isShotSelected(scene.id, shot.shotId)
                          "
                          (click)="selectShot(scene.id, shot.shotId, shot.id)"
                        >
                          <div class="shot-thumbnail">
                            <img
                              [src]="shot.image"
                              [alt]="'Shot ' + shot.shot_number"
                            />
                          </div>
                          <div class="shot-info">
                            <span class="shot-number"
                              >Shot {{ shot.shot_number }}</span
                            >
                            @if (shot.description) {
                              <span class="shot-description">{{
                                shot.description
                              }}</span>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
              }

              @if (scenes.length === 0) {
                <div class="no-scenes-message">
                  No scenes available. Please create a shotlist first.
                </div>
              }
            </div>
          </div>

          <!-- Prompts -->
          <div class="control-group">
            <div class="control-label">Action Prompt</div>
            <app-text-area
              [control]="getControl('actionPrompt')"
              [placeholder]="
                'Describe the movement (e.g. Slow cinematic push in, dust particles floating)...'
              "
              [label]="'Action Prompt'"
              [rowsCount]="3"
              [isFormSubmitted]="isFormSubmitted"
              class="textarea-input"
            >
            </app-text-area>
          </div>

          <div class="control-group">
            <div class="control-label">User Instruction</div>
            <app-text-area
              [control]="getControl('userInstruction')"
              [placeholder]="'Enter additional instructions or requirements...'"
              [label]="'User Instruction'"
              [rowsCount]="3"
              [isFormSubmitted]="isFormSubmitted"
              class="textarea-input"
            >
            </app-text-area>
          </div>

          <div class="control-group">
            <div class="control-label">
              <span>Dialogue Prompt</span>
              <button
                type="button"
                class="btn-ghost-small"
                (click)="addDialogueLine()"
              >
                + Add
              </button>
            </div>
            <div class="dialogue-container" formArrayName="dialogueLines">
              @for (
                dialogueGroup of dialogueLineFormGroups;
                track $index;
                let i = $index
              ) {
                <div class="dialogue-line" [formGroupName]="i">
                  <app-text-input
                    [control]="getDialogueCharacterControl(i)"
                    [placeholder]="'Character'"
                    [label]="'Character'"
                    [isFormSubmitted]="isFormSubmitted"
                    class="char-input"
                  >
                  </app-text-input>
                  <app-text-area
                    [control]="getDialogueLineControl(i)"
                    [placeholder]="'Line...'"
                    [label]="'Line'"
                    [rowsCount]="1"
                    [isFormSubmitted]="isFormSubmitted"
                    class="textarea-input"
                  >
                  </app-text-area>
                  @if (dialogueLinesFormArray.length > 1) {
                    <button
                      type="button"
                      class="btn-ghost-small btn-remove"
                      (click)="removeDialogueLine(i)"
                    >
                      ✕
                    </button>
                  }
                </div>
              }
            </div>
          </div>

          <!-- Parameters -->
          <div class="control-group">
            <div class="control-label">Parameters</div>

            <div class="params-grid">
              <div class="width-50">
                <span class="sub-label">Camera Angle</span>
                <app-select-input
                  [control]="getControl('cameraAngle')"
                  [placeholder]="'Select Camera Angle'"
                  [label]="'Camera Angle'"
                  [items]="cameraAngleOptions"
                  [valueKey]="'id'"
                  [labelKey]="'name'"
                  [isFormSubmitted]="isFormSubmitted"
                  class="common-dark-dropdown-v1 w-100"
                >
                </app-select-input>
              </div>
              <div class="width-50">
                <span class="sub-label">FPS</span>
                <app-select-input
                  [control]="getControl('fps')"
                  [placeholder]="'Select FPS'"
                  [label]="'FPS'"
                  [items]="fpsOptions"
                  [valueKey]="'id'"
                  [labelKey]="'name'"
                  [isFormSubmitted]="isFormSubmitted"
                  class="common-dark-dropdown-v1 w-100"
                >
                </app-select-input>
              </div>
            </div>

            <div class="params-grid">
              <div class="width-50">
                <span class="sub-label">Model</span>
                <app-select-input
                  [control]="getControl('model')"
                  [placeholder]="'Select Model'"
                  [label]="'Model'"
                  [items]="modelOptions"
                  [valueKey]="'model_id'"
                  [labelKey]="'model'"
                  [isFormSubmitted]="isFormSubmitted"
                  class="common-dark-dropdown-v1 w-100"
                >
                </app-select-input>
              </div>
              <div class="width-50">
                <span class="sub-label">Duration</span>
                <app-select-input
                  [control]="getControl('duration')"
                  [placeholder]="'Select Duration'"
                  [label]="'Duration'"
                  [items]="durationOptions"
                  [valueKey]="'id'"
                  [labelKey]="'name'"
                  [isFormSubmitted]="isFormSubmitted"
                  class="common-dark-dropdown-v1 w-100"
                >
                </app-select-input>
              </div>
            </div>

            <div class="camera-movement-select">
              <span class="sub-label">Camera Movement</span>
              <app-select-input
                [control]="getControl('cameraMovement')"
                [placeholder]="'Select Camera Movement'"
                [label]="'Camera Movement'"
                [items]="cameraMovementOptions"
                [valueKey]="'id'"
                [labelKey]="'name'"
                [isFormSubmitted]="isFormSubmitted"
                class="common-dark-dropdown-v1 w-100"
              >
              </app-select-input>
            </div>
          </div>

          <!-- Generate Video Button -->
          <button
            type="button"
            class="btn btn-purple w-100 d-flex justify-content-center"
            (click)="generateVideo()"
          >
            <span>🎬</span> Generate Video
          </button>
        </form>
      </div>
    </aside>

    <!-- Center: Result -->
    <main class="canvas-area">
      <button
        class="btn-ghost m-3 mb-0 position-absolute z-1"
        style="width: fit-content"
        (click)="switchView(null, 'home')"
      >
        ← Back to Grid
      </button>
      <div class="player-wrapper">
        <div class="video-player">
          <!-- Video Player Component -->
          <app-video-player [videoUrl]="currentVideoUrl"></app-video-player>

          @if (aivideos.length > 0) {
            <!-- Output Approval Overlay -->
            <div class="approval-bar">
              <button
                class="action-circle-btn btn-discard"
                title="Discard"
                (click)="approveVideo(false)"
              >
                ✕
              </button>
              <button
                class="action-circle-btn btn-approve"
                title="Approve to Project"
                (click)="checkAnyVideoIsApproved()"
              >
                ✓
              </button>
            </div>
          }
        </div>
      </div>

      <!-- Video List -->
      <div class="history-strip">
        @if (aivideos.length > 0) {
          @for (video of aivideos; track video.id) {
            <div
              class="history-item"
              [class.active]="selectedVideoId === video.id"
              (click)="selectVideo(video.id)"
            >
              @if (video.is_approved) {
                <div class="approved-video">
                  <app-icon name="check-green" size="16"></app-icon>
                </div>
              }
              <div class="history-thumb">
                <video [src]="video.url" muted></video>
                <div class="play-overlay">▶</div>
              </div>
              <div class="history-meta">
                <span>Video {{ video.id }}</span>
                <span>{{ formatDuration(video.duration) }}</span>
              </div>
            </div>
          }
        } @else {
          <div class="no-videos-message">
            <span>No videos available for this shot</span>
          </div>
        }
      </div>
    </main>

    <!-- Right Panel: Info -->
    @if (isRightPanelVisible) {
      <aside class="panel panel-right">
        <div class="panel-header">
          <div class="panel-header-content">
            <div class="panel-title">Generation Details</div>
            <div class="panel-subtitle">Metadata & Export</div>
          </div>
        </div>

        <div class="panel-content">
          @if (generationDetails && selectedVideoId) {
            <div class="details-section">
              <div class="control-label">Current Clip Info</div>
              <div class="prop-row">
                <span class="prop-label">Duration</span>
                <span class="prop-val">{{ generationDetails.duration }}</span>
              </div>
              <div class="prop-row">
                <span class="prop-label">FPS</span>
                <span class="prop-val">{{ generationDetails.fps }}</span>
              </div>
              <div class="prop-row">
                <span class="prop-label">Model</span>
                <span class="prop-val badge">{{
                  generationDetails.model
                }}</span>
              </div>
            </div>

            <div class="export-section">
              <button
                class="btn btn-primary justify-content-start export-btn w-100 mb-2"
                (click)="downloadMP4()"
              >
                Download MP4
              </button>
              <button
                class="btn btn-secondary-filled justify-content-start export-btn w-100 mb-2 fw-semibold"
                (click)="shareToReview()"
              >
                Share to Review
              </button>
              <button
                class="btn tertiary-button justify-content-start export-btn w-100"
                (click)="deleteVideo()"
              >
                Delete Video
              </button>
            </div>
          }
        </div>
      </aside>
    }
  </div>
}
